<template>
  <div id="app">
    <ParticleBackground />
    <!-- 流光线效果容器 -->
    <div class="glow-lines">
      <div class="glow-line glow-line-1"></div>
      <div class="glow-line glow-line-2"></div>
      <div class="glow-line glow-line-3"></div>
    </div>
    <!-- 流星效果 -->
    <div class="shooting-stars">
      <div class="shooting-star shooting-star-1"></div>
      <div class="shooting-star shooting-star-2"></div>
      <div class="shooting-star shooting-star-3"></div>
    </div>
    <div class="page-content">
      <router-view />
    </div>

    <!-- 音乐播放器（登录后显示） -->
    <MusicPlayer v-if="isLoggedIn" />
  </div>
</template>

<script>
import ParticleBackground from '@/components/ParticleBackground.vue'
import MusicPlayer from '@/components/MusicPlayer.vue'

export default {
  name: 'App',
  components: { ParticleBackground, MusicPlayer },
  computed: {
    isLoggedIn() {
      return !!this.$store.state.token
    }
  }
}
</script>

<style>
/* ===== Apple-Style Global Reset ===== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text",
               "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #ffffff;
  color: #1d1d1f;
  letter-spacing: -0.01em;
}

.page-content {
  position: relative;
  z-index: 1;
}

/* ===== 流光线效果 ===== */
.glow-lines {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.glow-line {
  position: absolute;
  height: 1px;
  opacity: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(180, 160, 220, 0.35) 20%,
    rgba(140, 180, 240, 0.5) 50%,
    rgba(180, 160, 220, 0.35) 80%,
    transparent 100%
  );
}

.glow-line-1 {
  top: 15%;
  width: 60%;
  left: -60%;
  animation: flowRight1 18s ease-in-out infinite;
  animation-delay: 0s;
}
.glow-line-2 {
  top: 45%;
  width: 50%;
  left: -50%;
  animation: flowRight2 22s ease-in-out infinite;
  animation-delay: 6s;
}
.glow-line-3 {
  top: 75%;
  width: 55%;
  left: -55%;
  animation: flowRight1 20s ease-in-out infinite;
  animation-delay: 12s;
}

@keyframes flowRight1 {
  0%   { transform: translateX(0); opacity: 0; }
  15%  { opacity: 0.6; }
  30%  { opacity: 0.7; }
  50%  { transform: translateX(calc(100vw + 60vw)); opacity: 0.5; }
  65%  { opacity: 0.1; }
  100% { transform: translateX(calc(100vw + 100vw)); opacity: 0; }
}

@keyframes flowRight2 {
  0%   { transform: translateX(0) translateY(0); opacity: 0; }
  10%  { opacity: 0.5; }
  25%  { opacity: 0.6; }
  40%  { transform: translateX(calc(80vw)) translateY(-30px); opacity: 0.4; }
  60%  { transform: translateX(calc(100vw + 50vw)) translateY(20px); opacity: 0.1; }
  100% { transform: translateX(calc(100vw + 100vw)) translateY(0); opacity: 0; }
}

/* ===== 流星效果 ===== */
.shooting-stars {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.shooting-star {
  position: absolute;
  top: -20px;
  width: 2px;
  height: 80px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.7),
    rgba(200, 180, 255, 0.4),
    rgba(200, 180, 255, 0)
  );
  border-radius: 2px;
  opacity: 0;
  animation: shoot 4s ease-in infinite;
}

.shooting-star::after {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 10px 2px rgba(200, 180, 255, 0.8),
              0 0 20px 4px rgba(180, 200, 255, 0.5),
              0 0 40px 8px rgba(200, 180, 255, 0.3);
}

.shooting-star-1 {
  left: 20%;
  animation-delay: 0s;
  transform: rotate(-25deg);
}
.shooting-star-2 {
  left: 55%;
  animation-delay: 8s;
  transform: rotate(-20deg);
}
.shooting-star-3 {
  left: 75%;
  animation-delay: 14s;
  transform: rotate(-30deg);
}

@keyframes shoot {
  0% {
    transform: rotate(-25deg) translateX(0) translateY(0);
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  15% {
    transform: rotate(-25deg) translateX(200px) translateY(300px);
    opacity: 0.8;
  }
  30% {
    transform: rotate(-25deg) translateX(600px) translateY(100vh);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

/* ===== Scrollbar ===== */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 2px;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* ===== Common Animations ===== */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.96); }
  to { opacity: 1; transform: scale(1); }
}
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
</style>
